export const roundPrice = (amount: number): number => {
    return Math.round(amount * 100) / 100
}

export const roundUnitPrice = (amount: number): number => {
    return Math.round(amount * 1000) / 1000
}

export const calculateVat = (gross: number, vatPercentage: number): number => {
    return gross - gross / (1 + vatPercentage / 100)
}

export const calculateNet = (gross: number, vatPercentage: number) => {
    return gross / (1 + vatPercentage / 100)
}

export const calculateGross = (net: number, vatPercentage: number) => {
    return net * (1 + vatPercentage / 100)
}

export const formatLisaAndNumber = (price: number) => Math.round(price * 100)

export const unformatLisaAndNumber = (price: number) => parseFloat((price / 100).toFixed(2))
